/* Customer attachment (UND-987): the pure logic behind the Change control that both the Application
   and Quote pages show for an application's attached customer. No network here — CustomerAttachment
   and ChangeCustomerDialog are the ones that call the API. */

import { apiErrorText } from '../utils/apiErrorText';

/** Mirrors ApplicationDAO#lockQuotesAndRefuseIfBound on the server: a quote counts as bound in effect
    once its status is bound or prebound, or it already carries a policy — a quote can move on to
    obsolete (e.g. superseded by a renewal) while remaining the one that wrote a policy. The Change
    control is hidden the moment any of an application's quotes meets this, so the underwriter never
    reaches the 409 the server would otherwise answer with. */
export const hasBoundQuote = (quotes) =>
  Array.isArray(quotes) && quotes.some((quote) => quote && (quote.status === 'bound' || quote.status === 'prebound' || !!quote.policyId));

/* PUT /applications/{id}/customer answers 400 with an "Unknown customerId: …" plain-text body and 409
   with a plain-text "has a bound quote" body — the same shape organisms/LossManagement's saveErrorText
   already parses for the loss grid's own saves, HTML error pages and 5xxes included, so this reuses that
   parsing (utils/apiErrorText.js) rather than keeping a second copy that could drift from it. */
export const customerAttachmentErrorText = (error, fallback = 'Could not change customer.') => apiErrorText(error, fallback);
